// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../src-custom-solutions/president-election/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".block-type-26[data-v-20baf12e]{text-align:center}", ""]);
// Exports
module.exports = exports;
